/**
 * Builds an API URL that stays inside the web artifact's base path in the
 * Replit preview, while resolving to /api/* on root-served deployments.
 */
export function getApiPath(endpoint: 'news' | 'market') {
  const basePath = import.meta.env.BASE_URL.replace(/\/$/, '');
  return `${basePath}/api/${endpoint}`;
}